import { call } from 'redux-saga/effects';
import { callWithAuth } from '../../sagaApiHelper';
import { uploadTemplateMediaApi } from '../../../api/apiLists/uploadTemplateMediaApi';
import { uploadBuffer } from '../fileUploadSaga';

const MEDIA_HEADER_FORMATS = ['image', 'video', 'document', 'audio'];

export function getTemplateHeaderMediaType(selectedTemplate) {
  let mediaType = 'image';
  if (!selectedTemplate?.components?.HEADER) {
    return mediaType;
  }

  try {
    const headerComponent = typeof selectedTemplate.components.HEADER === 'string'
      ? JSON.parse(selectedTemplate.components.HEADER)
      : selectedTemplate.components.HEADER;
    const format = headerComponent?.format?.toLowerCase();
    if (MEDIA_HEADER_FORMATS.includes(format)) {
      mediaType = format;
    }
  } catch (e) {
    if (selectedTemplate?.headerText) {
      mediaType = 'text';
    }
  }

  return mediaType;
}

export function parseS3FileUrl(fileURL) {
  if (typeof fileURL !== 'string' || !fileURL.startsWith('s3://')) {
    return { bucket: '', key: fileURL };
  }

  const parts = fileURL.replace('s3://', '').split('/');
  const bucket = parts.shift();
  const key = parts.join('/');
  return { bucket, key };
}

/**
 * Campaign / template header media: S3 presign + PUT, then Meta template media API for mediaId.
 * Used by campaignSaga.js and campaignScheduleSaga.js only.
 *
 * Workflow builder uses uploadWorkflowMediaToS3 (workflowMediaHelper.js) — URL only, no template API.
 * @returns {{ ok: true, mediaId: string|null }} | {{ ok: false, alertMessage: string, failureReason: string }}
 */
export function* uploadCampaignTemplateMedia({
  sendMediaFile,
  companyId,
  wabaId,
  displayPhoneNumberId,
}) {
  if (!sendMediaFile?.file?.file) {
    return { ok: true, mediaId: null };
  }

  const mediaFileName = sendMediaFile.file.name;
  const actualFile = sendMediaFile.file.file;
  const uploadContentType = actualFile?.type || 'application/octet-stream';

  const mediaUploadResult = yield call(uploadBuffer, {
    fileName: mediaFileName,
    contentType: uploadContentType,
    data: actualFile,
    customerId: companyId,
    operation: 'whatsapp-feature',
  });

  if (!mediaUploadResult?.fileURL) {
    return {
      ok: false,
      alertMessage: 'Failed to upload media',
      failureReason: 'Media upload failed',
    };
  }

  const { bucket: mediaBucket, key: mediaKey } = parseS3FileUrl(mediaUploadResult.fileURL);

  const mediaUploadRes = yield call(callWithAuth, uploadTemplateMediaApi, {
    wabaId,
    displayPhoneNumberId,
    mimeType: sendMediaFile.file?.type,
    source: 's3',
    bucket: mediaBucket,
    key: mediaKey,
  });

  if (mediaUploadRes?.status === true && mediaUploadRes?.data?.id) {
    return { ok: true, mediaId: mediaUploadRes.data.id };
  }

  const errorMsg = mediaUploadRes?.errMsg || mediaUploadRes?.data?.error || 'Failed to upload media';
  return {
    ok: false,
    alertMessage: `Media upload failed: ${errorMsg}`,
    failureReason: 'Media upload failed',
  };
}
